import React from "react";
import ReactMarkdown from "react-markdown";

const CareerSection2 = ({ academy }) => {
  // Custom components for markdown rendering
  const components = {
    p: ({ children }) => (
      <p className="text-[#666666] mb-2 max-w-2xl text-sm text-left">{children}</p>
    ),
    ul: ({ children }) => (
      <ul className="list-disc pl-4 mb-6 text-gray-600 max-w-2xl text-left">
        {children}
      </ul>
    ),
    li: ({ children }) => <li className="mb-2">{children}</li>,
    br: () => <br />,
  };

  return (
    <div className="py-2 px-6 bg-white mt-10">
      <div className="container mx-auto">
        <div className="mb-">
        <h2 className="text-xl text-left font-bold text-[rgb(62,89,183)] mb-2">
  Course objectives
</h2>

        </div>

        <div className="rounded-2xl px-4 text-left mt-4">
          <ReactMarkdown components={components} className="text-left">
            {academy.academyCourseObjective}
          </ReactMarkdown>
        </div>
      </div>
    </div>
  );
};

export default CareerSection2;
